<template>
  <div class="detials" v-loading="pageLoad">
    <!-- <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/order' }">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>查看订单</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card> -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="24">
          <span style="font-size: 14px; font-weight: 500; color: #000">订单信息</span>
          <span style="margin-left: 10px" class="paid style1" v-if="payForm.orderState == '已付款'">{{ payForm.orderState }}</span>
          <span style="margin-left: 10px" class="paid style2" v-if="payForm.orderState == '待付款'">{{ payForm.orderState }}</span>
          <span style="margin-left: 10px" class="paid style3" v-if="payForm.orderState == '已取消'">{{ payForm.orderState }}</span>
          <span style="margin-left: 10px" class="paid style4" v-if="payForm.orderState == '已退款'">{{ payForm.orderState }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="8">
          <span>单号：{{ payForm.number ? payForm.number : "" }}</span>
        </el-col>
        <el-col :span="8">
          <span>姓名：{{ payForm.student ? payForm.student.name : "" }}</span>
        </el-col>
        <el-col :span="8">
          <span>手机号：{{ payForm.student ? payForm.student.mobile : "" }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 20px">
        <!-- <el-col :span="8">
          <span>是否开票：{{payForm.agentId?payForm.agentId:''}}</span>
        </el-col>-->
        <el-col :span="8">
          <span>下单时间：{{ payForm.createTime ? payForm.createTime : "" }}</span>
        </el-col>
        <el-col :span="8">
          <span>订单来源：{{ payForm.sourceType ? payForm.sourceType : "" }}</span>
        </el-col>
        <el-col :span="8">
          <span>支付IP：{{ payForm.ip ? payForm.ip : "" }}</span>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" style="margin-top:20px;">
        <el-col :span="8">
          <span>下单时间：{{payForm.createTime?payForm.createTime:''}}</span>
        </el-col>
      </el-row>-->
      <el-table :data="payForm.orderItemList" tooltip-effect="dark" style="margin-top: 21px; width: 100%" border>
        <el-table-column show-overflow-tooltip prop="goodsName" label="商品名称" width="300">
          <template slot-scope="scope">
            <div class="goods">
              <img style="flex-shrink: 0" width="120" height="60" :src="
                scope.row.goodsLogo
                  ? scope.row.goodsLogo
                  : 'http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15743276279534477403800.png'
              " />
              <div style="margin-left: 10px">{{ scope.row.goodsName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="goodsPrice" label="售价（元）"></el-table-column>
        <el-table-column show-overflow-tooltip prop="goodsValidDay" label="有效期">
          <template slot-scope="row">
            <div>{{ row.row.goodsValidDay ? row.row.goodsValidDay + "天" : "不限" }}</div>
            <div>{{ row.row.delayDays ? "延期" + row.row.delayDays+ "天" : "" }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="goodsQuantity" label="数量"></el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip prop="goodsTotalAmount" label="总价"></el-table-column> -->
        <el-table-column show-overflow-tooltip label="操作人">
          <template>{{ payForm.agentUserName }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="goodsTotalAmount" label="所属科目">
          <template slot-scope="scope">{{
              scope.row.goodsInfo.subjectCourseName
          }}</template>
        </el-table-column>

        <el-table-column show-overflow-tooltip prop="goodsTotalAmount" label="操作">
          <template slot-scope="scope">
            <el-button v-auth="'/orderInfo/delayGoods_/order/detials'" @click="delayClick(scope.row)" type="text">延期</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-amount">
        <span>已选商品：{{
            payForm.orderItemList ? payForm.orderItemList.length : 0
        }}</span>
        <span>合计：￥{{ totals }}</span>
      </div>
      <!-- <div style="margin-top:20px;font-size:14px;font-weight:500;color:#000;">订单实付金额</div> -->
      <!-- <el-table
        :data="payForm.orderPaymentList"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
      >
        <el-table-column show-overflow-tooltip prop="channel" label="支付类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="paymentTime" label="时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tradeAmount" label="实付金额(元)"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tradePaymentAccount" label="付款账户"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tradeState" label="状态"></el-table-column>
      </el-table>-->
      <!-- <el-row :gutter="20" style="margin-top:20px;">
        <el-col :span="24">
          <span>收货地址：无锡市梁溪区中山路18号</span>
        </el-col>
      </el-row>-->
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="24">
          <span>联系人： {{ payForm.student ? payForm.student.name : "" }}</span>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 10px">
        <el-col :span="24">
          <span>电话： {{ payForm.student ? payForm.student.mobile : "" }}</span>
        </el-col>
      </el-row>
      <el-row v-if="payForm.orderState == '已取消'" :gutter="20" style="margin-top: 10px">
        <el-col :span="24">
          <span>取消时间： {{ payForm.updateTime }}</span>
        </el-col>
      </el-row>
      <div style="text-align: left; margin-top: 20px">
        <el-button type="primary" @click="Back">返 回</el-button>
      </div>
    </el-card>
    <el-dialog title="延期" :visible.sync="delayVisible" width="500px">
      <el-form ref="delayForm" :model="delayForm" label-width="80px" :rules="delayRules">
        <el-form-item label="延期天数" prop="goodsValidDay">
          <el-input-number :min="0" style="width: 100%" v-model="delayForm.goodsValidDay" label="描述文字"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="resetForm('delayForm')">取 消</el-button>
        <el-button type="primary" @click="submitDelay">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      studentId: "",
      payForm: {},
      pageLoad: false,
      totals: 0,
      delayVisible: false,
      delayForm: {
        goodsValidDay: undefined,
      },
      delayRules: {
        goodsValidDay: [
          { required: true, message: "请输入延期天数", trigger: "change" },
        ],
      },
    };
  },

  name: "App",
  computed: {},
  methods: {
    delayClick (record) {
      console.log(record, this.studentId);
      this.goodsId = record.goodsInfo.id;
      this.studentId = this.studentId;
      this.delayForm.goodsValidDay = record.goodsValidDay || undefined;
      this.delayVisible = true;
    },
    resetForm (formName) {
      //this.$refs[formName].resetFields();
      this.delayVisible = false;
    },
    submitDelay () {
      this.$refs.delayForm.validate((valid) => {
        if (valid) {
          console.log(this.studentId, 1);

          let param = {
            goodsId: this.goodsId,
            studentId: this.studentId,
            goodsValidDay: this.delayForm.goodsValidDay.toString(),
            id: this.$route.query.id,
          };
          console.log(this.studentId, 1, param, this.studentId * 1);
          this.api.subjectCourse
            .delayGoods(param)
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: result.message,
                  type: "success",
                });
                this.delayVisible = false;
                this.getOrderInfo();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    Back () {
      this.$router.go(-1);
    },
    getOrderInfo () {
      let that = this;
      this.pageLoad = true;
      this.api.orderInfo
        .getOrderInfo({
          id: this.$route.query.id,
        })
        .then((result) => {
          this.pageLoad = false;
          if (result.success) {
            this.totals = 0;
            that.studentId = result.data.userId;
            if (result.data.orderItemList) {
              result.data.orderItemList.forEach((element) => {
                this.totals = this.totals + element.goodsTotalAmount;
              });
            }

            this.payForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted () {
    this.getOrderInfo();
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.el-select {
  width: 100% !important;
}

.paid {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}

.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}

.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}

.style4 {
  background: rgb(255, 100, 107);
  border: solid 1px rgb(255, 100, 107);
}

.goods {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}

.table-amount {
  height: 40px;
  width: 100%;
  border: 1px solid #d9ebf5;
  box-sizing: border-box;
  border-top: 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
  color: #333333;
  font-weight: bold;

  span {
    margin-right: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/orderInfo/detial.vue